export enum EVENTS {
  PAGEVIEW = 'PAGEVIEW',
  PRIERE_START = 'PRIERE_START',
  PRIERE_INTERRUPTED = 'PRIERE_INTERRUPTED',
  PRIERE_FINISHED = 'PRIERE_FINISHED',
  PRIERE_AMEN_CLICKED = 'PRIERE_AMEN_CLICKED',
  INTENTION_ADDED = 'INTENTION_ADDED',
  INTENTION_DELETED = 'INTENTION_DELETED',
  INTENTIONS_SHUFFLE = 'INTENTIONS_SHUFFLE',
  ALERT_BANNER_DISPLAYED = 'ALERT_BANNER_DISPLAYED',
  ALERT_BANNER_CLICKED = 'ALERT_BANNER_CLICKED',
  POST_PRAY_INTENTION_POPIN_DISPLAYED = 'POST_PRAY_INTENTION_POPIN_DISPLAYED',
  POST_PRAY_INTENTION_POPIN_CONTINUE = 'POST_PRAY_INTENTION_POPIN_CONTINUE',
  POST_PRAY_INTENTION_UPLIFT_FORM_DISPLAYED = 'POST_PRAY_INTENTION_UPLIFT_FORM_DISPLAYED',
  POST_PRAY_INTENTION_UPLIFT_LEAVE_INTENTION = 'POST_PRAY_INTENTION_UPLIFT_LEAVE_INTENTION',
  POST_PRAY_PUBLICATION_DISPLAYED = 'POST_PRAY_PUBLICATION_DISPLAYED',
  POST_PRAY_INTENTION_CREATION_POST_INTENTION_DISPLAYED = 'POST_PRAY_INTENTION_CREATION_POST_INTENTION_DISPLAYED',
  POST_PRAY_INTENTION_CREATION_POST_INTENTION_CLICKED = 'POST_PRAY_INTENTION_CREATION_POST_INTENTION_CLICKED',
  POST_PRAY_INTENTION_CREATION_PRAY_INTENTION_DISPLAYED = 'POST_PRAY_INTENTION_CREATION_PRAY_INTENTION_DISPLAYED',
  POST_PRAY_INTENTION_CREATION_PRAY_INTENTION_CLICKED = 'POST_PRAY_INTENTION_CREATION_PRAY_INTENTION_CLICKED',
  POST_PRAY_INTENTION_CREATION_DISPLAYED = 'POST_PRAY_INTENTION_CREATION_DISPLAYED',
  POST_PRAY_PUBLICATION_POST_INTENTION_DISPLAYED = 'POST_PRAY_PUBLICATION_POST_INTENTION_DISPLAYED',
  POST_PRAY_PUBLICATION_POST_INTENTION_CLICKED = 'POST_PRAY_PUBLICATION_POST_INTENTION_CLICKED',
  POST_PRAY_PUBLICATION_PRAY_INTENTION_DISPLAYED = 'POST_PRAY_PUBLICATION_PRAY_INTENTION_DISPLAYED',
  POST_PRAY_PUBLICATION_PRAY_INTENTION_CLICKED = 'POST_PRAY_PUBLICATION_PRAY_INTENTION_CLICKED',
  WATCHMAN_CTA_DISPLAYED = 'WATCHMAN_CTA_DISPLAYED',
  WATCHMAN_CTA_REFUSED = 'WATCHMAN_CTA_REFUSED',
  WATCHMAN_CTA_CLICKED = 'WATCHMAN_CTA_CLICKED',
  PARTAGE_WHATSAPP = 'PARTAGE_WHATSAPP',
  PARTAGE_MAILTO = 'PARTAGE_MAILTO',
  PARTAGE_COPY = 'PARTAGE_COPY',
  AUTO_BANNER_DONATE_LATER_CLICKED = 'AUTO_BANNER_DONATE_LATER_CLICKED',
  DON_DONATE_LATER_CLICKED = 'DON_DONATE_LATER_CLICKED',
  AUTO_BANNER_CLOSED = 'AUTO_BANNER_CLOSED',
  DON_BANNER_CLOSED = 'DON_BANNER_CLOSED',
  AUTO_BANNER_DISPLAYED = 'AUTO_BANNER_DISPLAYED',
  DON_BANNER_DISPLAYED = 'DON_BANNER_DISPLAYED',
  AUTO_BANNER_FORM_SUBMITTED = 'AUTO_BANNER_FORM_SUBMITTED',
  DON_FORM_SUBMITTED = 'DON_FORM_SUBMITTED',
  COMMUNITY_JOINED_NOTIFS_DISPLAYED = 'COMMUNITY_JOINED_NOTIFS_DISPLAYED',
  COMMUNITY_JOINED_NOTIFS_ACCEPTED = 'COMMUNITY_JOINED_NOTIFS_ACCEPTED',
  COMMUNITY_JOINED_NOTIFS_REFUSED = 'COMMUNITY_JOINED_NOTIFS_REFUSED',
  COMMUNITY_JOINED_EMAILS_DISPLAYED = 'COMMUNITY_JOINED_EMAILS_DISPLAYED',
  COMMUNITY_JOINED_EMAILS_ACCEPTED = 'COMMUNITY_JOINED_EMAILS_ACCEPTED',
  COMMUNITY_JOINED_EMAILS_REFUSED = 'COMMUNITY_JOINED_EMAILS_REFUSED',
  COMMUNITY_JOIN_SUCCESS = 'COMMUNITY_JOIN_SUCCESS',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_DISPLAYED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_DISPLAYED',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_SHARE_CLICKED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_SHARE_CLICKED',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_PRAY_INTENTION_CLICKED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_PRAY_INTENTION_CLICKED',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_LEAVE_INTENTION_DISPLAYED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_LEAVE_INTENTION_DISPLAYED',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_LEAVE_INTENTION_SUBMITTED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_LEAVE_INTENTION_SUBMITTED',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_CLOSED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_CLOSED',
  COMMUNITY_JOINED_NEXT_NOT_STARTED_CTA_CLICKED = 'COMMUNITY_JOINED_NEXT_NOT_STARTED_CTA_CLICKED',
  COMMUNITY_JOINED_NEXT_STARTED_DISPLAYED = 'COMMUNITY_JOINED_NEXT_STARTED_DISPLAYED',
  COMMUNITY_JOINED_NEXT_STARTED_PRAY_PUBLICATION_CLICKED = 'COMMUNITY_JOINED_NEXT_STARTED_PRAY_PUBLICATION_CLICKED',
  COMMUNITY_JOINED_NEXT_STARTED_CLOSED = 'COMMUNITY_JOINED_NEXT_STARTED_CLOSED',
  PUSH_PERMISSION_TRIGGERED = 'PUSH_PERMISSION_TRIGGERED',
  PUSH_PERMISSION_GRANTED = 'PUSH_PERMISSION_GRANTED',
  PUSH_PERMISSION_DENIED = 'PUSH_PERMISSION_DENIED',
  PUSH_PERMISSION_IGNORED = 'PUSH_PERMISSION_IGNORED',
  PUBLICATION_CARD_CLICK = 'PUBLICATION_CARD_CLICK',
  SUGGESTIONS_SECTION_VISIBLE = 'SUGGESTIONS_SECTION_VISIBLE',
  PWA_UPDATE_FOUND = 'PWA_UPDATE_FOUND',
  PWA_UPDATED = 'PWA_UPDATED',
  XMRPM_CTA_DISPLAYED = 'XMRPM_CTA_DISPLAYED',
  XMRPM_CTA_CLICKED = 'XMRPM_CTA_CLICKED',
  XMRPM_CTA_DISMISSED = 'XMRPM_CTA_DISMISSED',
  PRAYER_SPACE_VARIANT_ASSIGNED = 'PRAYER_SPACE_VARIANT_ASSIGNED',
  PRAYER_SPACE_ONBOARDING_DISPLAY = 'PRAYER_SPACE_ONBOARDING_DISPLAY',
  PRAYER_SPACE_ONBOARDING_CLOSED_STEP_1 = 'PRAYER_SPACE_ONBOARDING_CLOSED_STEP_1',
  PRAYER_SPACE_ONBOARDING_CLOSED_STEP_2 = 'PRAYER_SPACE_ONBOARDING_CLOSED_STEP_2',
  PRAYER_SPACE_ONBOARDING_CLOSED_STEP_3 = 'PRAYER_SPACE_ONBOARDING_CLOSED_STEP_3',
  PRAYER_SPACE_ONBOARDING_CLOSED_STEP_4 = 'PRAYER_SPACE_ONBOARDING_CLOSED_STEP_4',
  WATCHMAN_ASK_PUSH_DISPLAYED = 'WATCHMAN_ASK_PUSH_DISPLAYED',
  WATCHMAN_ASK_PUSH_CLICKED = 'WATCHMAN_ASK_PUSH_CLICKED',
  WATCHMAN_ASK_PUSH_REFUSED = 'WATCHMAN_ASK_PUSH_REFUSED',
  VIRTUS_DOWNLOAD_APP_DISPLAYED = 'VIRTUS_DOWNLOAD_APP_DISPLAYED',
  VIRTUS_DOWNLOAD_APP_CLICKED = 'VIRTUS_DOWNLOAD_APP_CLICKED',
  VIRTUS_DOWNLOAD_APP_CLOSED = 'VIRTUS_DOWNLOAD_APP_CLOSED',
}
